export default __webpack_public_path__ + "static/media/Grizzly.da1b7adc.jpg";